import { getApiService } from '@/services/api';

const SETTINGS_PATH = '/system/setting';

export enum SettingType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  SECRET = 'secret'
}

export interface Setting {
  id: string;
  scope: string;
  key: string;
  valueType: SettingType;
  valueText: string;
  description?: string;
}

export class SettingsApi {
  private static getApiInstance() {
    return getApiService();
  }

  static async getAll() {
    const apiService = this.getApiInstance();
    return await apiService.client.get(SETTINGS_PATH);
  }

  static async create(data: Omit<Setting, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.post(SETTINGS_PATH, data);
  }

  static async update(id: string, data: Omit<Setting, 'id'>) {
    const apiService = this.getApiInstance();
    return await apiService.client.put(`${SETTINGS_PATH}/${id}`, data);
  }

  static async delete(id: string) {
    const apiService = this.getApiInstance();
    return await apiService.client.delete(`${SETTINGS_PATH}/${id}`);
  }
}
